import React, { useEffect } from "react";
import WaitlistForm from "./WaitlistForm";
import "./ComingSoonModal.css";

const ComingSoonModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div className="coming-soon-overlay" onClick={onClose}>
      <div
        className="coming-soon-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="coming-soon-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="coming-soon-mark" aria-hidden="true">
          <svg viewBox="0 0 32 32" fill="none">
            <path
              d="M16 6c-2.8 4.4-8 7.2-8 12.2A8 8 0 0 0 16 26a8 8 0 0 0 8-7.8C24 13.2 18.8 10.4 16 6Z"
              stroke="currentColor"
              strokeWidth="1.7"
            />
            <path
              d="M16 14v8M12.5 18.5h7"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <h2 id="coming-soon-title">The EldyCare app is coming soon</h2>
        <p>
          Leave your city, email and pincode so we can tell you when the app
          launches in your area — Noida first, then Delhi, Gurugram, Faridabad
          and more.
        </p>

        <WaitlistForm submitLabel="Notify me" />

        <button className="coming-soon-later" type="button" onClick={onClose}>
          Maybe later
        </button>
        <p className="coming-soon-stores">
          Available soon on App Store and Google Play.
        </p>
      </div>
    </div>
  );
};

export default ComingSoonModal;
